module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("BIOGRAPHY OF BARBARA C. JORDAN")]), _vm._v(" (1936-1996)")]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("Barbara Jordan’s distinguished public service career began with her election to the Texas Legislature in 1966. Jordan’s victory made her the first African American woman to serve in the Texas Senate and the first African American elected to that body since 1883. In 1972 she became the first African American woman from the South to be elected to the United States Congress, serving as a member of the House of Representatives until 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The highlights of Jordan’s legislative career include her landmark speech during Richard Nixon’s impeachment hearings in 1974, her successful efforts in 1975 to expand the Voting Rights Act to include language minorities, and her keynote address to the Democratic National Convention in 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From 1979 until her death in 1996, Jordan served as a distinguished professor at the Lyndon B. Johnson School of Public Affairs at the University of Texas at Austin, holding the Lyndon B. Johnson Centennial Chair in National Policy. Her students knew her as a rigorous mentor and a dedicated professor. The word “teacher” is part of her epitaph and serves as a potent reminder of her commitment to what she considered the most important role of her lifetime.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The list of accolades bestowed upon Barbara Jordan is rich and varied. She was the recipient of thirty-one honorary doctorates and numerous national awards. In 1994 President Bill Clinton presented her with the Presidential Medal of Freedom, and in 1999 "), _c('em', [_vm._v("Texas Monthly")]), _vm._v(" magazine named her “Role Model of the Century.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jordan was born February 21, 1936, in Houston, one of three daughters of a Baptist preacher and warehouse clerk. She attended public schools and graduated from Texas Southern University, "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("where she majored in political science. She received her law degree in 1959 from Boston University."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ich01not1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("STUDENT COMMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("These statements reflect Barbara Jordan’s continuing influence on her students’ lives:")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Professor Jordan makes you look at your soul.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• She has a driving concern about the world. She cares about it, and she wants us to go out there and make a difference in a positive way.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Her ideas of social commitment and social consciousness have framed my life. She is convincing us that we have to, in a sense, pay rent for the space that we occupy.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• I’ve never met a person who believed so strongly that we can actually change the world. That gives me confidence that we really can.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Above all else, she has taught me that greatness, more than power or fame, is something you do every day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("When you listen to their comments, you know that you are hearing something fundamental about leadership, about education, about public service, and about the relationship between a teacher and her students.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0003-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_vm._v("Making a point during the Summer Minority Advancement Program at "), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")]), _vm._v(" Austin’s "), _c('span', {
    staticClass: "small"
  }, [_vm._v("LBJ")]), _vm._v(" School of Public Affairs. Photo by María de la Luz Martínez, courtesy of the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("LBJ")]), _vm._v(" School of Public Affairs, University of Texas at Austin.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0004-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_vm._v("Jordan during an interview with "), _c('em', [_vm._v("Family Circle")]), _vm._v(" magazine, October 10, 1976. In the background is Lady Bird Johnson. "), _c('span', {
    staticClass: "small"
  }, [_vm._v("LBJ")]), _vm._v(" Library photo by Frank Wolf, courtesy of the Lyndon B. Johnson Presidential Library, Austin.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0004-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_vm._v("Congresswoman Barbara Jordan in her Washington office. Photo courtesy of Barbara Jordan Archives, Robert James Terry Library, Texas Southern University, Houston.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c62556b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 90
// module chunks = 0